import {
  Grid,
  Button,
  ButtonGroup,
  InputAdornment,
  Typography,
} from "@mui/material";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { GrMonospace } from "react-icons/gr";
import "../../whatsapp interface/WhatsappPreview.css";
import React, { useState, useRef, useEffect } from "react";
import { FaItalic, FaBold, FaStrikethrough, FaSmile } from "react-icons/fa";

import {
  ComponentHeader,
  Paper,
  TextField,
  Label,
} from "../../../../components";

export default function TemplateBody({ formikProps, addSample }) {
  const [showEmoji, setShowEmoji] = useState(false);

  const onEmojiClick = (emoji) => {
    console.log(emoji);
    formikProps.setFieldValue(
      "templateBody.text",
      (formikProps.values.templateBody?.text || "") + emoji.native
    );
  };

  const handleAddVariable = () => {
    var textHeader = document.getElementsByName("templateBody.text")[0].value;
    var count_var_1 = (textHeader.match(/\{{/g) || []).length;

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateBody: setVariables(prevVal.templateBody),
    }));
    function setVariables(templateBody) {
      templateBody.text = textHeader + "{{" + (count_var_1 + 1) + "}}";
      templateBody.count_of_variable = count_var_1 + 1;
      return templateBody;
    }
  };

  const handleBodyChange = (event) => {
    var textHeader = document.getElementsByName("templateBody.text")[0].value;
    var count_var_1 = (textHeader.match(/\{{/g) || []).length;

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      templateBody: setVariables(prevVal.templateBody),
    }));
    function setVariables(templateBody) {
      templateBody.text = event.target.value;
      templateBody.count_of_variable = count_var_1 === 0 ? 0 : count_var_1;
      templateBody.example = [];
      return templateBody;
    }
  };

  let useClickForOutside = (handler) => {
    let emoji = useRef();

    useEffect(() => {
      let maybeHandler = (event) => {
        if (!emoji.current?.contains(event.target)) {
          handler();
        }
      };
      document.addEventListener("mousedown", maybeHandler);
      return () => {
        document.removeEventListener("mousedown", maybeHandler);
      };
    });

    return emoji;
  };

  let emoji = useClickForOutside(() => {
    setShowEmoji(false);
  });

  const makeItAsSelected = (key) => {
    var symbol1;
    var symbol2;
    if (key === "bold") {
      symbol1 = "*";
      symbol2 = "*";
    } else if (key === "italic") {
      symbol1 = "_";
      symbol2 = "_";
    } else if (key === "strikethrough") {
      symbol1 = "~";
      symbol2 = "~";
    } else if (key === "monospace") {
      symbol1 = "```";
      symbol2 = "```";
    }
    var selectedField = document.getElementById("bodyText");
    var start = selectedField.selectionStart;
    var end = selectedField.selectionEnd;
    var t = selectedField.value.substr(
      selectedField.selectionStart,
      selectedField.selectionEnd - selectedField.selectionStart
    );
    if (start >= 0 && end !== 0 && Boolean(t)) {
      var text = selectedField.innerHTML;

      text = text.split("");

      text.splice(start, 0, symbol1);
      text.splice(end + 1, 0, symbol2);

      text = text.join("");

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        templateBody: setText(prevVal.templateBody),
      }));
      function setText(templateBody) {
        templateBody.text = text;
        return templateBody;
      }

      selectedField.focus();
    }
  };

  return (
    <Paper>
      <Grid style={{ alignSelf: "center" }} item xs={12}>
        <ComponentHeader title={"Template Body"} />
        <Typography
          variant="subtitle2"
          gutterBottom
          style={{ color: "#808080b3" }}
        >
          Enter the text for your message in the language you have selected. You
          can use as many variables. While using Bold, Italic, Strikethrough
          make sure there should not be any space between the word and symbol.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Label
          formikProps={formikProps}
          name="templateBody.text"
          title="Body Text"
          required={true}
        />

        <TextField
          placeholder="Body Text"
          id="bodyText"
          name="templateBody.text"
          fullWidth
          required
          multiline
          case="none"
          onChange={handleBodyChange}
          rows={5}
          formikProps={formikProps}
          disabled={
            Boolean(formikProps.values.ID) ||
            Boolean(addSample) ||
            formikProps.isSubmitting
          }
          inputProps={{
            maxLength: 1024,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {formikProps.values?.templateBody?.text?.length}/1024
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item />
      <Grid textAlign={"end"} item xs>
        {/* <Button
          disabled={Boolean(formikProps.values.ID) || Boolean(addSample)}
          variant="outlined"
          color="primary"
          onClick={handleAddVariable}
        >
          <Add /> &nbsp;Add Variable
        </Button> */}
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 2,
        }}
      >
        <ButtonGroup
          variant="outlined"
          sx={{
            height: 40,
            "& .MuiButton-root": {
              minWidth: 42,
              width: 42,
              height: 40,
              padding: 0,
            },
          }}
        >
          <Button
            onClick={() => makeItAsSelected("italic")}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
          >
            <FaItalic />
          </Button>

          <Button
            onClick={() => makeItAsSelected("bold")}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
          >
            <FaBold />
          </Button>

          <Button
            onClick={() => makeItAsSelected("strikethrough")}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
          >
            <FaStrikethrough />
          </Button>

          <Button
            onClick={() => makeItAsSelected("monospace")}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
          >
            <GrMonospace />
          </Button>
        </ButtonGroup>

        <div
          ref={emoji}
          style={{
            position: "relative",
            display: "inline-flex",
            marginLeft: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setShowEmoji((prev) => !prev)}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
            style={{
              width: 42,
              minWidth: 42,
              height: 40,
              padding: 0,
            }}
          >
            <FaSmile />
          </Button>

          {showEmoji && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                right: 0,
                zIndex: 9999,
              }}
            >
              <Picker
                data={data}
                onEmojiSelect={onEmojiClick}
                previewPosition="none"
              />{" "}
            </div>
          )}
        </div>
      </Grid>
    </Paper>
  );
}
